<template>
  <div class="row">
    <div class="col-3">
      <h3>Draggable 1</h3>
      <draggable
        class="dragArea list-group"
        :list="list1"
        :group="{ name: 'blocks', pull: 'clone', put: false }"
        :clone="cloneDog"
        
      >
        <div class="list-group-item" v-for="element in list1" :key="element.id">
          {{ element.name }}
        </div>
      </draggable>
    </div>

    <div class="col-3">
      <h3>Draggable 2</h3>
      <draggable
        class="dragArea list-group"
        :list="list2"
        group="blocks"
        
      >
        <div class="list-group-item" v-for="element in list2" :key="element.id">
          {{ element.content }}
        </div>
      </draggable>
    </div>

  </div>
</template>

<script>

let idGlobal = 8;
export default {
  name: "custom-clone",
  display: "Custom Clone",
  order: 3,
  components: {
    draggable
  },
  data() {
    return {
      list1: [
        { name: "dog 1", id: 1 },
        { name: "dog 2", id: 2 },
        { name: "dog 3", id: 3 },
        { name: "dog 4", id: 4 }
      ],
      list2: []
    };
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    cloneDog({ id }) {

    this.log(id);

      return {
        id: idGlobal++,
        content: '<div>ksdhjkjhdf dfjkhgdf kdjfhgkdfjhsdf gkjfsdh gkjdgfs fdkjgh dfkj gfhjk ksdfjh</div>'
      };
    }
  }
};
</script>
<style scoped></style>